// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".freighth5-drawer-content{height:100%;width:100%;padding:1.041667rem;font-size:1.354167rem;overflow:hidden}.freighth5-drawer-content ul{height:100%;overflow-y:auto}.freighth5-drawer-content ul li{text-align:center;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;padding:.520833rem 0}.freighth5-drawer-content ul .activeli{font-size:1.458333rem;color:#409eff}", ""]);
// Exports
module.exports = exports;
